var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('h2', [_vm._v(" " + _vm._s(_vm.$t('Calib Table')))]), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "600px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v(" id ")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(" Probe ID ")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(" Height ")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(" Volume ")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v(" Diff ")])])]), _c('tbody', _vm._l(_vm.data, function (item, n) {
          return _c('tr', {
            key: item.name
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(n + 1))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(item.probe_id || _vm.probe_id))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(item.height))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(item.volume))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(item.diff))])]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }